module.exports = "/images/pregnancy.png?db03f7dcbdc9e83d3d7f2a223d2db03a";